import React from 'react';

const IcDelete = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.8228 24L19.6472 7.86365H4.81415L5.6385 24H18.8228ZM10.7275 1.89496L5.43189 0L4.72754 1.89496L19.7275 7L20.4319 5.10504L15.3741 3.54991L15.9376 2.03374L11.291 0.37774L10.7275 1.89496ZM8.7671 10.4348L7.12988 10.5204L7.72988 21.9131L9.36814 21.8275L8.7671 10.4348ZM13.1664 10.4693H11.5281V21.8786H13.1664V10.4693ZM15.9274 10.4348L17.5647 10.5204L16.9647 21.9131L15.3264 21.8275L15.9274 10.4348Z'
        fill='#DA072D'
      />
    </svg>
  );
};

export default IcDelete;
